/** Whether members can book seats in a Session's occurrences from the member portal. */
export enum BookingMode {
  Closed = "Closed",
  OpenAutoConfirm = "OpenAutoConfirm",
  OpenWithConfirmation = "OpenWithConfirmation",
}
